

export default [
   
    {
        path: "api-keys",
        name: "DevelopersApiKeys",
        meta:{
            permissionPath: 'developers.api_keys.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "developersApiKeys" */ "@/views/general/settings/developers/tabs/ApiKeys.vue"
            )
    },

    {
        path: "webhooks",
        name: "DevelopersWebhooks",
        meta:{
            permissionPath: 'developers.webhooks.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "developersWebhooks" */ "@/views/general/settings/developers/tabs/Webhooks.vue"
            )
    },
    

    {
        path: "webhook-responses",
        name: "DevelopersWebhookResponses",
        meta:{
            permissionPath: 'developers.webhooks_responses.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "developersWebhookResponses" */ "@/views/general/settings/developers/tabs/WebhookResponses.vue"
            )
    },
    

    {
        path: "webhook-logs",
        name: "DevelopersWebhookLogs",
        meta:{
            permissionPath: 'developers.webhooks_logs.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "developersWebhookLogs" */ "@/views/general/settings/developers/tabs/WebhookLogs.vue"
            )
    },

];
